<template>
    <v-group>
        <!--各カーテンの書き出し-->
        <v-group
                v-for="item in list"
                :key="item.id"
                :opacity="edit_mode === CONST.EDIT_MODE_CLIPPING || ((is_operating || is_loading) && editing_id === item.id) || item.item_data.name === '' ? 0 : 1"
        >
            <v-image
                    :config="{hitFunc: generateHitFunc(item), ...item.image_config}"
                    @click="activate(item.id)"
                    @tap="activate(item.id)"
            ></v-image>
        </v-group>
    </v-group>
</template>

<script>
    import CONST from '../../../assets/js/const'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import EditRectDefault from './EditRectDefault'
    export default {
        name: "EditImages",
        components: { EditRectDefault },
        data: () => ({
            CONST,
        }),
        computed: {
            ...mapState(["edit_mode", "is_loading"]),
            ...mapState('simulator', ['image_list', 'editing_id', 'is_operating']),
            ...mapGetters('simulator', ['sorted_image_list']),
            list: _this => [..._this.sorted_image_list].reverse().filter(item => !!item.image_config)
        },
        methods: {
            ...mapActions('simulator', ["setEditingId"]),
            generateHitFunc(item) {
                const {points, image_config} = item;
                if (!points || !image_config) return () => {};
                return function (context, shape) {
                    context.beginPath();
                    context.moveTo(points.top_left.x - image_config.x, points.top_left.y - image_config.y);
                    context.lineTo(points.top_right.x - image_config.x, points.top_right.y - image_config.y);
                    context.lineTo(points.bottom_right.x - image_config.x, points.bottom_right.y - image_config.y);
                    context.lineTo(points.bottom_left.x - image_config.x, points.bottom_left.y - image_config.y);
                    context.closePath();
                    context.fillStrokeShape(shape);
                }
            },
            activate(id) {
                //アクティブ無しの状態からカーテンを選択したときに実行される
                this.$emit('activateCurtain');
                this.setEditingId(id);
            },
        }
    }
</script>

<style scoped>

</style>
